import React from "react";
import { type LucideIcon } from "lucide-react";
import { SYS_LEVEL_STYLES, SYS_STATUS_STYLES } from "../constants";

export function SysLevelPill({ level }: { level: string | null | undefined }) {
  if (!level) return <span className="text-sm text-muted-foreground">—</span>;
  const key = level.toLowerCase();
  const cls = SYS_LEVEL_STYLES[key] || SYS_LEVEL_STYLES.low;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border capitalize ${cls}`}
    >
      {key}
    </span>
  );
}

export function SysStatusPill({ status }: { status: string | null | undefined }) {
  if (!status) return <span className="text-sm text-muted-foreground">—</span>;
  const key = status.toLowerCase();
  const cls = SYS_STATUS_STYLES[key] || SYS_STATUS_STYLES.other;
  const label = key.replace(/-/g, " ");
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border capitalize ${cls}`}
    >
      {label}
    </span>
  );
}

export function SysCharRow({
  icon: Icon,
  label,
  children,
}: {
  icon: LucideIcon;
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-[240px_1fr] gap-2 sm:gap-4 py-3 items-start">
      <div className="flex items-center gap-2.5">
        <div className="flex items-center justify-center size-7 rounded-md bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 flex-shrink-0">
          <Icon className="size-3.5" />
        </div>
        <span className="text-xs font-medium text-muted-foreground">
          {label}
        </span>
      </div>
      <div className="text-sm text-foreground/90 min-w-0 sm:pt-1">
        {children}
      </div>
    </div>
  );
}

export function ImpactPill({ level }: { level: string | null | undefined }) {
  const key = (level || "").toLowerCase();
  const cls = SYS_LEVEL_STYLES[key] || SYS_LEVEL_STYLES.low;
  const label = key ? key.charAt(0).toUpperCase() + key.slice(1) : "—";
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border min-w-[90px] justify-center ${cls}`}
    >
      {label}
    </span>
  );
}
